"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconMenu = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.54 17.885v-2.15h18.6v2.15H2.54Zm0-5.034V10.7h18.6v2.15H2.54Zm0-5.035v-2.15h18.6v2.15H2.54Z"
}));
exports.IconMenu = IconMenu;
//# sourceMappingURL=IconMenu.js.map